import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, switchMap, catchError, withLatestFrom } from 'rxjs/operators';

import { CodeSetResponse } from '../codeset/codeset.model';
import {
  loadCodeSet,
  loadCodeSetSuccess,
  loadCodeSetError,
} from './codeset.actions';

import { of, EMPTY } from 'rxjs';
import { CodesetService } from '../codeset/codeset.service';
import { CodesetFacade } from './codeset.facade';

@Injectable()
export class CodesetEffects {
  constructor(
    private actions$: Actions,
    private codesetService: CodesetService,
    private codesetFacade: CodesetFacade,
  ) {}

  codeSet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCodeSet),
      withLatestFrom(this.codesetFacade.codeSetResponse$),
      switchMap(([, codeset]) => {
        if (!codeset) {
          return this.codesetService.getCodeSet().pipe(
            map((codeSetResponse: CodeSetResponse) =>
              loadCodeSetSuccess({ payload: codeSetResponse }),
            ),
            catchError((error) => of(loadCodeSetError({ error }))),
          );
        }
        return EMPTY;
      }),
    ),
  );
}
